import { Addon } from '@domain/addon';
import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';

interface AddonsPresetParams {
  eventId: string;
  isAssigned: boolean;
}

const getPresetAddons = async ({ companyClubId, params }: { companyClubId: string; params?: AddonsPresetParams }) => {
  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/company-clubs/${companyClubId}/add-on-presets${
    params ? `?eventId=${params.eventId}&isAssigned=${params.isAssigned}&limit=100` : '?limit=100'
  }`;

  return request({ url, method: RequestMethod.GET });
};

export const getAddonsPresetsQueryKey = (companyClubId: string) => [QUERY_KEYS.getAddonsPresets, companyClubId];

export const useGetAddonsPresets = ({
  companyClubId,
  params,
  enabled = true,
}: {
  companyClubId: string;
  params?: AddonsPresetParams;
  enabled?: boolean;
}) => {
  return useGenericQuery<Addon[], RequestError>(
    [QUERY_KEYS.getAddonsPresets, companyClubId],
    () => getPresetAddons({ companyClubId, params }),
    {
      enabled: enabled && !!companyClubId,
    }
  );
};
